<template>
  <div class="d-flex flex-column gap-2">
    <CustomCheck
      v-for="(option, index) in repeatOptions"
      :key="index"
      :label="option.label"
      @change="(e) => changeModel(e, option.value)"
      v-model="data[option.value]"
    />
  </div>
</template>

<script>
import CustomCheck from "@/v3components/shared/Form/CustomCheck.vue"
import { onMounted, reactive } from "vue"

export default {
  components: {
    CustomCheck
  },
  name: "TardyRadioGroupOld",
  props: ["value", "modelValue"],
  emits: ["update:modelValue", "input"],
  setup(props, { emit }) {
    const data = reactive({
      LTS: false,
      LTC: false
    })

    const repeatOptions = [
      {
        label: "Late to School",
        value: "LTS"
      },
      {
        label: "Late to Class",
        value: "LTC"
      }
    ]

    const changeModel = (isChecked, value) => {
      if (value === "LTS" && isChecked) {
        // When user clicks on LTS, we need to set LTC to false and LTS to true
        data.LTS = true
        data.LTC = false
      } else if (value === "LTC" && isChecked) {
        // When user clicks on LTC, we need to set LTS to false and LTC to true
        data.LTC = true
        data.LTS = false
      } else {
        // In other cases, we need to set both to false
        data.LTS = false
        data.LTC = false
      }
      const modelValue = data.LTS ? "LTS" : data.LTC ? "LTC" : ""
      emit("input", modelValue)
      emit("update:modelValue", modelValue)
    }

    onMounted(() => {
      data.LTS = props.modelValue === "LTS"
      data.LTC = props.modelValue === "LTC"
    })

    return {
      data,
      repeatOptions,
      props,
      changeModel
    }
  }
}
</script>
